import { Injectable } from '@angular/core';
import {
  CanActivate, CanActivateChild, Router,
  ActivatedRouteSnapshot, RouterStateSnapshot
} from '@angular/router';
import { of as observableOf, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { SessionService } from 'src/app/shared/services/session.service';

@Injectable()
export class StaffGuard implements CanActivate, CanActivateChild {
  constructor(
    private sessionService: SessionService,
    private router: Router
  ) { }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this._isStaff();
  }

  canActivateChild(_childRoute: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this._isStaff();
  }

  private _isStaff(): Observable<boolean> {
    return this.sessionService.userData().pipe(
      map(userData => {
        const ok = !!(userData?.user?.is_superuser || userData?.user?.is_staff);

        if (!ok) {
          this.router.navigate(['/']);
        }

        return ok;
      }),
      catchError(() => {
        this.router.navigate(['/']);
        return observableOf(false);
      })
    );
  }
}
